module.exports = "/_next/static/images/marinala-98f9c8140c45297603c8708d83351ec5.jpg";